import styles from './Availability.module.scss?module';
import { ProductAttributeInterface } from '../../../../Interface/ProductAttribute';
import { formatDate } from '../../../Helper/formatter';

export default function Availability({
  product_attribute,
}: {
  product_attribute: ProductAttributeInterface;
}) {
  return (
      <div className={`d-flex align-items-center h-100 p-0`}>
        <div
          className={['d-flex align-items-center', styles.availability].join(
            ' '
          )}
        >
          <span
            className={[
              styles.dot,
              product_attribute.has_stock ? 'bg-success' : 'bg-danger',
              'me-sm-2',
            ].join(' ')}
          />

          <span className="d-md-inline d-none">
            {product_attribute.eta ? (
              <span className="lh-1">{`ETA: ${formatDate(
                product_attribute.eta
              )}`}</span>
            ) : (
              <span>
                {product_attribute.has_stock ? 'In stock' : 'Out of stock'}
              </span>
            )}
          </span>
        </div>
      </div>
  );
}
